import { Box, Typography } from '@capitalise/ui-design-system';
import { cloneElement } from 'react';

interface IMenuSectionProps {
  title?: string;
  showTitle: boolean;
  menus: JSX.Element[];
}

const MenuSection = ({ title, showTitle = true, menus }: IMenuSectionProps) => {
  return (
    <Box display="flex" flexDirection="column" gridGap="3xsmall">
      {title && showTitle && (
        <Typography pt="small" px="xsmall" size="section-header-14">
          {title}
        </Typography>
      )}
      {menus.map((menu) => cloneElement(menu))}
    </Box>
  );
};

export default MenuSection;
